import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCocktail: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCocktail"><Path d="M4.49294 3C2.03184 3 1.05171 6.18184 3.08621 7.56667L11.5003 13.2939V21H7.50031C7.22417 21 7.00031 21.2239 7.00031 21.5C7.00031 21.7761 7.22417 22 7.50031 22H16.5003C16.7765 22 17.0003 21.7761 17.0003 21.5C17.0003 21.2239 16.7765 21 16.5003 21H12.5003V13.2939L20.9144 7.56667C22.9489 6.18184 21.9688 3 19.5077 3H4.49294Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCocktail;
